import { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import { AuthContext } from '../contexts/jwt-auth-context';

export const useAuth = () => useContext(AuthContext);
